__turbopack_context__.v({
  "dropdown": "Nf01Wa_dropdown",
  "option": "Nf01Wa_option",
  "selected": "Nf01Wa_selected",
  "target": "Nf01Wa_target",
});
